import { Paragraph } from 'hui';
import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { EventActions, EventCategories } from '../../../constants/Analytics';

const ArticleStyle = styled.div`
  && a {
    color: ${props => props.theme.colors.primary};
    text-decoration: underline;
  }
`;

interface ArticleSuggestionsProps {
  prevArticle?: any;
  nextArticle?: any;
}

const ArticleSuggestions: React.FC<ArticleSuggestionsProps> = ({ prevArticle, nextArticle }) => (
  <ArticleStyle>
    <Paragraph>
      <strong>You might also like:</strong>
      &nbsp;
      {prevArticle ? (
        <Link
          to={`/article/${prevArticle.key}`}
          data-ga-category={EventCategories.ARTICLES}
          data-ga-action={EventActions.PREVIOUS_ARTICLE_CLICK_LINK}
          data-ga-label={`[/article/${prevArticle.key}]`}
        >
          {prevArticle.name}
        </Link>
      ) : (
        ``
      )}
      {prevArticle && nextArticle ? `, ` : ``}
      {nextArticle ? (
        <Link
          to={`/article/${nextArticle.key}`}
          data-ga-category={EventCategories.ARTICLES}
          data-ga-action={EventActions.NEXT_ARTICLE_CLICK_LINK}
          data-ga-label={`[/article/${nextArticle.key}]`}
        >
          {nextArticle.name}
        </Link>
      ) : (
        ``
      )}
    </Paragraph>
  </ArticleStyle>
);

ArticleSuggestions.propTypes = {
  prevArticle: PropTypes.object,
  nextArticle: PropTypes.object
};

export default ArticleSuggestions;
